import {Component,HostListener,Inject} from "@angular/core";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {Filter} from "@domain/common/list-view";

/**
 * Composant d'affichage des filtres de liste
 */
@Component({
    host: {'data-test-id': 'list-view-filters-popup'},
    selector: 'list-view-filters-popup',
    templateUrl: './list-view-filters-popup.component.html',
    styleUrls: ['./list-view-filters-popup.component.scss']
})
export class ListViewFiltersPopupComponent {

    /**
     * Constructeur
     */
    constructor(
        protected matDialogRef: MatDialogRef<ListViewFiltersPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { listeFilters: Filter[], filterClick: () => void }
    ) {}

    /**
     * Clic sur un filtre
     *
     * @param filter filtre concerné
     */
    onFilterClick(filter: Filter) {
        //Si le filtre n'est pas un filtre caché par défaut
        if (!filter.isHiddenByDefault) {
            //On inverse la valeur
            filter.isSelected = !filter.isSelected;
        }

        //Apparition du filtre s'il était caché par défaut
        filter.isHiddenByDefault = false;

        //Exécution du callback associé au clic sur un filtre
        this.data.filterClick();
    }

    /**
     * Fermeture de la fenêtre sur pression d'une des touches entrée ou escape
     */
    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        //Si la touche pressée est entrée ou escape
        if (event.key === 'Escape' || event.key === 'Enter') {
            //Fermeture de la fenêtre
            this.matDialogRef.close();
        }
    }
}
